export default "__VITE_ASSET__DWIlcJ8w__"